import React, { useState, useMemo, useEffect } from "react";
import axios from "axios";
import toast from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL;

// 1. Move initialState outside the component.
// It's now a true constant, created only once.
const initialState = {
    customername: "", address1: "", address2: "", city: "",
    state: "", pincode: "", mobile: "", email: "", tinno: ""
};

const AddCustomerModal = ({ isOpen, onClose, onSuccess }) => {
    const [form, setForm] = useState(initialState);
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const token = localStorage.getItem("token");
    const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

    // 2. The linter warning will now be gone.
    // This effect is now correctly defined.
    useEffect(() => {
        if (isOpen) {
            setForm(initialState);
        }
    }, [isOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.customername) {
            toast.error("Customer Name is required.");
            return;
        }
        setIsSubmitting(true);
        try {
            await axios.post(`${API_URL}/customers`, form, { headers });
            toast.success("Customer added successfully!");
            onSuccess();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Failed to add customer.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Add New Customer</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit} className="add-customer-form">
                        <div className="form-group"><label htmlFor="customername">Customer Name*</label><input id="customername" name="customername" value={form.customername} onChange={handleChange} required /></div>
                        <div className="form-group"><label htmlFor="mobile">Mobile</label><input id="mobile" name="mobile" value={form.mobile} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="email">Email</label><input id="email" name="email" type="email" value={form.email} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="tinno">GST Number</label><input id="tinno" name="tinno" value={form.tinno} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="address1">Address Line 1</label><input id="address1" name="address1" value={form.address1} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="address2">Address Line 2</label><input id="address2" name="address2" value={form.address2} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="city">City</label><input id="city" name="city" value={form.city} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="state">State</label><input id="state" name="state" value={form.state} onChange={handleChange} /></div>
                        <div className="form-group"><label htmlFor="pincode">Pincode</label><input id="pincode" name="pincode" value={form.pincode} onChange={handleChange} /></div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
                            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>{isSubmitting ? "Saving..." : "Save Customer"}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddCustomerModal;